module.exports = __webpack_public_path__ + "img/riego.553ba478.png";